import React, { useMemo } from 'react';
import { getNumbersWithDecimalPlaces, getNumberWithCommas } from '../../../utilities/money';
import { resolveAddress } from '../../../services/contactAndContract';
import { CHAIN_EXPLORER } from '../../../constants/chains';
import { getDateTimeFromTimestamp } from '../../../utilities/datetime';
import WalletAddressEllipsis from '../../../components/shared/WalletAddressEllipsis';
import HashDetails from './HashDetails';
import AddressDetails from './AddressDetails';
import SentDetails from './SentDetails';
import TokenDetails from './TokenDetails';

const exchangeTransactionDetails = ({ data }) => {
  const capitalizeFirstLetter = (text) => (text ? text[0].toUpperCase() + text.substring(1) : text);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const checkHashLink = useMemo(() => {
    if (data?.chain?.id) {
      return `${CHAIN_EXPLORER[data?.chain?.id]}tx/${data.txid}`;
    } else {
      return `https://etherscan.io/tx/${data.txid}`;
    }
  }, [data]);

  return (
    <div className="custom-sdls-left-top-margin">
      <section className="slds-p-around_large">
        <div className="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center slds-m-bottom_large">
          <div className="transaction_detail_half_details">
            <p>Account</p>
            <p style={{ fontWeight: '700' }}>{data.account_name}</p>
          </div>
          <div className="slds-col_padded" style={{ maxWidth: '542px' }}>
            <p>Transaction ID</p>
            <p style={{ fontWeight: '700' }} title={data.txid}>
              {resolveAddress(data.txid).name ? (
                resolveAddress(data.txid).name
              ) : (
                <WalletAddressEllipsis text={data?.txid} maxTextCount={20} />
              )}
            </p>
          </div>
        </div>
        <div className="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center slds-m-bottom_large">
          <div className="transaction_detail_half_details">
            <p>TX Type</p>
            <p style={{ fontWeight: '700' }}>{data && data.type === 'deposit' ? 'Buy' : 'Sell'}</p>
          </div>

          <div className="transaction_detail_half_details">
            <p>Date</p>
            <p style={{ fontWeight: '700' }}>{getDateTimeFromTimestamp(data.timestamp)}</p>
          </div>
        </div>
        <div className="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center slds-m-bottom_large">
          <div className="transaction_detail_half_details">
            <p>To</p>
            <p style={{ fontWeight: '700' }}>
              {data && data.address ? (
                resolveAddress(data.address)?.name ? (
                  resolveAddress(data.address)?.name
                ) : (
                  <div title={data.address}>
                    <WalletAddressEllipsis
                      text={data.address}
                      maxTextCount={20}
                      title={data.address}
                    />
                  </div>
                )
              ) : (
                'Unknown'
              )}
            </p>
          </div>

          <div className="transaction_detail_half_details">
            <p>Amount</p>
            <p style={{ fontWeight: '700' }} title={data?.amount}>
              {data && getNumberWithCommas(getNumbersWithDecimalPlaces(data?.amount || 0))}{' '}
              {data && data.currency}
            </p>
          </div>
        </div>
        <div className="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center slds-m-bottom_large">
          <div className="transaction_detail_half_details">
            <p>Status</p>
            <p style={{ fontWeight: '700' }}>{data && capitalizeFirstLetter(data.status)}</p>
          </div>

          <div className="transaction_detail_half_details">
            <p>Fee</p>
            <p style={{ fontWeight: '700' }} title={data?.fee?.cost}>
              {data && getNumberWithCommas(getNumbersWithDecimalPlaces(data?.fee?.cost || 0))}{' '}
              {data && data?.fee?.currency}
            </p>
          </div>
        </div>
        {data.txid && (
          <div className="home_card">
            <HashDetails data={data.txid} />
          </div>
        )}

        {data.address && data.address_name && (
          <div className="home_card">
            <AddressDetails address={data.address} name={data.address_name} />
          </div>
        )}

        {data.sends && data.sends.length > 0 && (
          <div className="home_card">
            <SentDetails data={data.sends} linkTo={`${checkHashLink}`} />
          </div>
        )}
        <TokenDetails data={data} />
      </section>
    </div>
  );
};

export default exchangeTransactionDetails;
